<template>
  <div>
    <el-row>
      <el-select
        v-model="value"
        placeholder="Select"
        @change="getWithYear"
        style="float: right; margin-left: 10px"
      >
        <el-option
          v-for="item in options"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="interactionSelected"
        placeholder="Tipo de interaccion"
        filterable
        clearable
        @change="getWithYear"
        style="float: right; margin-left: 10px"
      >
        <el-option
          v-for="item in interactionList"
          :key="item.InteractionTemplateCode"
          :label="item.InteractionTemplateDescription"
          :value="item.InteractionTemplateCode"
        >
        </el-option>
      </el-select>

      <el-select
        v-model="Deparament"
        placeholder="Departamento"
        @change="getDepartament"
        filterable
        @clear="CreatedDocument"
        clearable
        style="float: right; margin-left: 10px"
      >
        <el-option
          v-for="item in Deparaments"
          :key="item.value"
          :label="item.Label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-select
        v-model="Employee"
        placeholder="Empleados"
        filterable
        clearable
        @change="getEmployee"
        style="float: right"
        :disabled="isEnable"
      >
        <el-option
          v-for="item in Employees"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-row>
    <el-row>
      <rabbey-table2
        :columns="columns"
        show-summary
        :summary-method="getSummaries"
        v-loading="detailTableLoading"
      />
    </el-row>
    <!-- <rabbey-table-3
      :loading="mainTableLoading"
      :data="getSummaries"
      :columns="columns"
    /> -->
    <el-drawer
      title="Detalle de Interacciones"
      :visible="openDetail"
      :before-close="CloseTransactionDetail"
      size="60%"
    >
      <el-row style="margin-top: 20px">
        <el-form label-position="top">
          <el-col :span="11" style="margin-left: 20px">
            <el-form-item label="Agente de Cobro">
              <el-input
                v-model="interaccionDeatail.PersonName"
                disabled
                style="width: 300px"
              />
            </el-form-item>
          </el-col>

          <el-col :span="11">
            <el-form-item label="Mes">
              <el-input
                v-model="interaccionDeatail.Month"
                disabled
                style="width: 300px"
              />
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="10">
          <!-- <el-card :body-style= "{width: '10000px'}" shadow="always">
      Vistas
      </el-card> -->
        </el-col>
        <el-col :span="8">
          <card-total text="Canceladas" />
        </el-col>

        <el-col :span="4" style="margin-left: 20px">
          <el-tag>Correos {{ this.emailCount }} </el-tag>
        </el-col>
        <el-col :span="4"
          ><el-tag type="success">Visitas: {{ this.visitaCount }}</el-tag>
        </el-col>
        <el-col :span="4">
          <el-tag type="danger">Llamada: {{ this.llamadaCount }}</el-tag>
        </el-col>
        <el-col :span="4"></el-col>

        <el-col :span="11">
          <el-select
            v-model="DaySelected"
            placeholder="Dias del mes"
            filterable
            clearable
            @change="DaySelectedFuntion"
            style="float: right; margin-left: 10px"
          >
            <el-option
              v-for="item in days"
              :key="item.Dias"
              :label="item.DiaDelMes"
              :value="item.Dias"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <!-- <el-select
            v-model="interactionSelected"
            placeholder="Tipo de interaccion"
            filterable
            clearable
            @change="InteractionType"
            style="float: right; margin-left: 10px"
          >
            <el-option
              v-for="item in interactionList"
              :key="item.InteractionTemplateCode"
              :label="item.InteractionTemplateDescription"
              :value="item.InteractionTemplateCode"
            >
            </el-option>
          </el-select> -->
        </el-col>
      </el-row>

      <div>
        <DetailChart ref="detailChart" :DetailParams="DetailData" />
      </div>

      <h2 style="margin-left: 20px">Listado de Interacciones</h2>

      <rabbey-table-3
        :loading="detailTableLoading"
        :data="interaccionDeatail.interaccionList"
        :columns="interacciones"
        style="margin: 20px"
      />
    </el-drawer>
    <el-drawer
      title="Detalle de Clientes"
      :visible="visibleDetailClientes"
      :before-close="CloseTransactionDetail"
      size="60%"
    >
      <el-row style="margin-top: 20px" :gutter="20">
        <el-form label-position="top">
          <el-col :span="6" style="margin-left: 20px">
            <el-form-item label="Agente de Servicio al Cliente">
              <el-input v-model="ExecCustomer" disabled style="width: 300px" />
            </el-form-item>
          </el-col>
          <el-col :span="4" :offset="9">
            <el-select
              v-model="CustomersExcList2"
              placeholder="Servicio al Clientes"
              filterable
              clearable
              @change="CustomersExc"
              style="float: right"
            >
              <el-option
                v-for="item in CustomersExcList"
                :key="item.CODE"
                :label="item.Nombre"
                :value="item.CODE"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" round @click="onSubmit"
              >Reasignar Clientes</el-button
            >
          </el-col>
        </el-form>
      </el-row>
      <rabbey-table-3
        :checkBox="true"
        @selection-change="handleSelectionChange"
        :loading="detailTableLoading"
        :data="DetailsCustomers"
        :columns="ItemsCustomers"
        style="margin: 20px"
      />
    </el-drawer>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
import DetailChart from "@/views/Charts/MagynetInteractionsChart.vue";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import InteractionDetailsHyperLink from "@/components/functionals/InteractionDetailsHyperLink.vue";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import DatetimeFormatterColor from "@/components/functionals/DatetimeFormatterColor.vue";
import InteractionTypeTagFormatter from "@/components/functionals/InteractionTypeTagFormatter.vue";
import ImagePersonVue from "@/components/functionals/ImagePerson.vue";
import ColorType from "@/components/functionals/ColorType.vue";
// import { mapActions, mapState } from "vuex";
import CardTotal from "@/components/CardTotalOriginal.vue";
function renderNumber(val) {
  if (val) {
    return val;
  }
  return "";
}
export default {
  components: { RabbeyTable3, DetailChart, CardTotal },
  name: "Interactions",
  data() {
    return {
      //year: 0,
      interactionSelected: "",
      DaySelected: null,
      options: [],
      value: this.year,
      ItemsCheckedfromDb: [],
      unformatedDescription: [],
      openDetail: false,
      detailTableLoading: false,
      interactionList: [],
      Deparament: "",
      CustomersExcList2: "",
      isEnable: true,
      CustomersExcList: [],
      DetailsCustomers: [],
      row: [],
      column: "",
      datetime: "",
      ItemsCheck: [],
      ExecCustomer: "",
      days: [],
      visibleDetailClientes: false,
      GroupTypes: {
        47: "SRVCLIENTE",
        32: "DPTOVENTAS",
        38: "DPTOFINAN"
      },
      ItemsCustomers: [
        {
          prop: "No_",
          label: "Codigo",
          minWidth: 200,
          sortable: true
        },
        {
          prop: "Name",
          label: "Nombre del Cliente",
          minWidth: 200,
          sortable: true
        },

        {
          prop: "Clasificacion",
          label: "Clasificacion",
          minWidth: 150,
          sortable: true,
          formatter: ColorType
        },
        {
          prop: "EMail",
          label: "Email",
          minWidth: 200,
          sortable: true
        },
        {
          prop: "Contact",
          label: "Contacto",
          minWidth: 200,
          sortable: true
        }
      ],
      Deparaments: [
        {
          Label: "Servicio al cliente",
          value: 47
        },
        {
          Label: "Ventas",
          value: 32
        },
        {
          Label: "Cuentas por Cobrar",
          value: 38
        }
      ],
      Employee: "",
      Employees: [],
      interaccionDeatail: {
        PersonName: "",
        Month: "",
        interaccionList: []
      },
      interacciones: [
        {
          prop: "Date",
          label: "Fecha",
          minWidth: 200,
          formatter: DatetimeFormatter,
          sortable: true
          // fixed: true
        },
        {
          prop: "Date",
          label: "Hora",
          minWidth: 200,
          formatter: DatetimeFormatterColor,
          sortable: true
          // fixed: true
        },
        {
          prop: "TipoDescripcion",
          label: "Tipo",
          minWidth: 200,
          formatter: InteractionTypeTagFormatter
          // fixed: true
        },
        {
          prop: "ClientName",
          label: "Cliente",
          minWidth: 250
          // fixed: true
        },
        {
          prop: "iterationDescription",
          label: "Descripcion",
          minWidth: 200,
          // fixed: true
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "SalesPersonPhoto"
          }
        },
        {
          prop: "Conclusion",
          label: "Conclusión",
          minWidth: 200
          // fixed: true
        }
      ],

      columns: [
        {
          prop: "Name",
          name: "Persona",
          minWidth: 260,
          fixed: true,
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "EmployeePhoto"
          }
        },
        {
          prop: "NoClientes",
          name: "Cantidad de clientes",
          minWidth: 180,

          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetailClientes
          }
        },
        {
          prop: "monto",
          name: "Facturacion Mensual",
          minWidth: 180,
          formatter: (props) => {
            if (props.monto != 0) {
              return new Intl.NumberFormat("en-US").format(props.monto);
            } else {
              return "";
            }
          }
        },
        {
          prop: "January",
          name: "Enero",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "february",
          name: "Febrero",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "march",
          name: "Marzo",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "april",
          name: "Abril",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "may",
          name: "Mayo",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "june",
          name: "Junio",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "july",
          name: "Julio",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "august",
          name: "Agosto",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "september",
          name: "Septiembre",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "october",
          name: "Octubre",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "november",
          name: "Noviembre",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "december",
          name: "Diciembre",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "Totals",
          name: "Totales",
          formatter: (row) => renderNumber(row.Totals)
        }
      ],
      DetailData: {
        Year: 0,
        Month: 0,
        CompanyId: "",
        UserName: "",
        InteractionType: "",
        day: 0
      },

      llamadaCount: 0,
      visitaCount: 0,
      emailCount: 0
    };
  },
  beforeCreate() {
    var fecha = new Date();
    this.year = fecha.getFullYear();
  },
  created() {
    this.CreatedDocument();
    this.getInteractionType();
    this.yearCalculator();
    this.GetCustomersExcList();
  },

  methods: {
    CreatedDocument() {
      this.isEnable = true;
      this.Employees = [];
      this.detailTableLoading = true;
      this.$store
        .dispatch("rabbey_table/getItems", {
          url: "/api/SalesApi/interactionsSummary",
          params: {
            "criteria.year": this.value,
            "criteria.companyId": this.currentCompany,
            "criteria.companyCode": this.currentCompany,
            "criteria.Type": null
          }
        })
        .then(() => {
          this.detailTableLoading = false;
        });
    },

    async getDepartament() {
      this.Employees = [];
      await this.$http
        .get(
          `/api/interactions/GetEmployeeByDepartament?id=${Number(
            this.Deparament
          )}`
        )
        .then((resp) => {
          resp.data.forEach((element) => {
            this.Employees.push({
              label: element.FullName,
              value: element.Id
            });
          });
        });
      this.getInterections(
        Number(this.Deparament),
        "interactionsSummary",
        null
      );
      this.isEnable = false;
    },
    getEmployee() {
      this.getInterections(
        Number(this.Deparament),
        "interactionsSummary",
        this.Employee
      );
    },

    getWithYear() {
      //this.Employees = [];
      //this.isEnable = true;
      this.getInterections(null, "interactionsSummary", null);
    },
    getInterections(Deparament, endpoint, userName) {
      this.detailTableLoading = true;
      this.$store
        .dispatch("rabbey_table/getItems", {
          url: `/api/SalesApi/${endpoint}`,
          params: {
            "criteria.year": this.value,
            "criteria.companyId": this.currentCompany,
            "criteria.companyCode": this.currentCompany,
            "criteria.Type": this.interactionSelected,
            "criteria.GroupCode":
              this.Deparament === "" ? Deparament : Number(this.Deparament),
            "criteria.empID": this.Employee === "" ? userName : this.Employee
          }
        })
        .then(() => {
          this.detailTableLoading = false;
        });
    },
    yearCalculator() {
      for (var i = 2019; i <= this.year; i++) {
        this.options.push(i);
      }
    },
    OpenInteractionDetail(row, column) {
      this.datetime = this.getMonthNumber(column);
      this.getdays();
      this.row = row;
      this.column = column;
      this.detailTableLoading = true;
      this.interaccionDeatail.PersonName = this.row.Name;
      this.interaccionDeatail.Month = this.column;
      this.emailCount = 0;
      this.llamadaCount = 0;
      this.visitaCount = 0;
      this.DetailData = {
        Year: this.value,
        Month: this.getMonthNumber(this.column),
        CompanyId: this.currentCompany,
        UserName: row.Code,
        InteractionType: this.interactionSelected,
        day: this.DaySelected
      };
      this.$http
        .get("/api/SalesApi/interactions", {
          params: {
            Year: this.DetailData.Year,
            Month: this.DetailData.Month,
            CompanyCode: this.DetailData.CompanyId,
            UserName: this.DetailData.UserName,
            TypeOf: "c",
            day: this.DaySelected,
            Type: this.interactionSelected
          }
        })
        .then((resp) => {
          const items = resp.data.Items;
          items.forEach((item) => {
            const tipo = item.Type || "";
            console.log(item);
            this.unformatedDescription.push(item.Conclusion);
            var str = item.Conclusion.replace(/(<([^>]+)>)/gi, "");
            var html = str;

            var div = document.createElement("div");
            div.innerHTML = html;
            var text = div.textContent || div.innerText || "";

            item.Conclusion = text;

            if (tipo.includes("LLAMADA")) {
              this.llamadaCount++;
            } else if (tipo.includes("VISITA")) {
              this.visitaCount++;
            } else if (tipo.includes("EMAIL")) {
              this.emailCount++;
            }
          });

          this.interaccionDeatail.interaccionList = resp.data.Items;
          this.detailTableLoading = false;
          this.$refs.detailChart.getChartData();
        });
      this.openDetail = true;
    },
    CloseTransactionDetail() {
      this.visibleDetailClientes = false;
      this.openDetail = false;
      this.interaccionDeatail.interactionList = [];
      this.$refs.detailChart.bar.series[0].data = [];
      this.$refs.detailChart.loading = true;
    },
    getMonthNumber(month) {
      switch (month) {
        case "January":
          return 1;
        case "february":
          return 2;
        case "march":
          return 3;
        case "april":
          return 4;
        case "may":
          return 5;
        case "june":
          return 6;
        case "july":
          return 7;
        case "august":
          return 8;
        case "september":
          return 9;
        case "october":
          return 10;
        case "november":
          return 11;
        case "december":
          return 12;
      }
    },

    getInteractionType() {
      this.$http
        .get("/api/interactions/getInteractionCode", {
          params: {
            "criteria.companyId": this.currentCompany,
            "criteria.page": 1,
            "criteria.limit": 999
          }
        })
        .then((resp) => {
          this.interactionList = resp.data.Items;
          this.interactionList.push(
            {
              InteractionTemplateDescription: "Llamadas",
              InteractionTemplateCode: "Llamada"
            },
            {
              InteractionTemplateDescription: "Visitas",
              InteractionTemplateCode: "VISITA"
            }
          );
        });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Totales";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    OpenInteractionDetailClientes(row) {
      this.ExecCustomer = row.Name;
      this.visibleDetailClientes = true;
      this.GetDetailsCustomers(row.CodeExec);
    },
    handleSelectionChange(val) {
      this.Checked = [];
      if (val.length <= 0) {
        this.Checked = [];
      } else {
        val.forEach((value) => {
          const { No_, Name, EMail, Contact, Clasificacion } = value;

          this.Checked.push({
            No_,
            Name,
            EMail,
            Contact,
            Clasificacion
          });
        });
        this.ItemsCheck = this.Checked;
      }
    },
    GetDetailsCustomers(CodeExec) {
      if (CodeExec == null) {
        CodeExec = 0;
      }
      this.$http
        .get(`/api/SalesApi/GetCustomersList?UserId=${CodeExec}`)
        .then((resp) => {
          this.DetailsCustomers = resp.data;
        });
    },
    onSubmit() {
      const isValid = this.IsInRole(this.roles.ReasignaciondeClientes);
      if (isValid) {
        this.ItemsCheck.forEach((value) => {
          this.UpdateCustomerExec(value.No_, this.CustomersExcList2);
        });
      } else {
        this.$message.warning(
          "Lo sentimos usted no tiene acceso a reasignar clientes"
        );
      }
    },

    CustomersExc() {},
    GetCustomersExcList() {
      this.$http.get(`/api/SalesApi/GetCustomersExcList`).then((resp) => {
        this.CustomersExcList = resp.data;
      });
    },
    UpdateCustomerExec(CustomerCode, ServicesCustomerCode) {
      this.$http
        .post(
          `/api/SalesApi/UpdateCustomerExec?CustomerCode=${CustomerCode}&ExecCustomerCode=${ServicesCustomerCode}`
        )
        .then((resp) => {
          if (resp.data == 1) {
            this.CreatedDocument();
            this.CustomersExcList2 = "";
            this.visibleDetailClientes = false;

            this.message({
              type: "success",
              message: "Reasignado Correctamente"
            });
            this.CreatedDocument();
          } else {
            this.message({
              type: "danger",
              message: "ERROR"
            });
          }
        });
      // .then((resp) => {
      //   this.CustomersExcList=resp.data
      // })
    },
    InteractionType() {
      this.OpenInteractionDetail(this.row, this.column);
    },
    getdays() {
      this.$http
        .get(`/api/SalesApi/DaybyMonth?datetime=${this.datetime}`)
        .then((resp) => {
          this.days = resp.data;
        });
    },
    DaySelectedFuntion() {
      this.OpenInteractionDetail(this.row, this.column);
      console.log(this.DaySelected);
    }
  }
};
</script>

<style scoped></style>
